module.exports = __webpack_public_path__ + "static/media/36.1b95cb96.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/36.png
// module id = 540
// module chunks = 0